import React from "react"
import { Card, Space, Tag } from "antd"
import MovementAttachmentUploader from "../common/MovementAttachmentUploader"

export interface MovementDetailAttachmentsCardProps {
  movementId?: number
  movementUid: string
  attachments: any[]
  docType: string
  onAttachmentsChange: (newAttachments: any[]) => void
}

const MovementDetailAttachmentsCard: React.FC<MovementDetailAttachmentsCardProps> = ({
  movementId,
  movementUid,
  attachments,
  docType,
  onAttachmentsChange,
}) => {
  return (
    <Card
      title={
        <Space>
          <span>Documentos y Soportes Adjuntos</span>
          <Tag color="blue" style={{ borderRadius: 10 }}>
            {attachments?.length || 0}
          </Tag>
        </Space>
      }
      style={{ marginTop: 24 }}
      className="card-shadow"
    >
      <MovementAttachmentUploader
        movementId={movementId}
        movementUid={movementUid}
        value={attachments || []}
        onChange={onAttachmentsChange}
        directApi={true}
        defaultDocType={docType}
      />
    </Card>
  )
}

export default MovementDetailAttachmentsCard
